<template>
  <div id="app" style="width: 100%">
    <div class="page-header">
      <div class="page-title">摄像头列表</div>
      <div class="page-header-btn">
<!--        <el-button icon="el-icon-plus" size="mini" style="margin-right: 1rem;" type="primary" @click="add">添加</el-button>-->
        <el-button icon="el-icon-refresh-right" circle size="mini" :loading="getShipListLoading"
                   @click="getVideoList()"></el-button>
      </div>
    </div>
    <!--设备列表-->
    <el-table :data="videoList" border style="width: 100%;font-size: 12px;">
      <el-table-column prop="cameraIndex" label="视频位置" width="120" align="center" />
      <el-table-column prop="id" label="摄像头id" align="center" />
      <el-table-column prop="name" label="摄像头名称" align="center"/>
      <el-table-column prop="manufacture" label="厂商" align="center"/>
      <el-table-column prop="shipName" label="所属船舶" align="center"/>
      <!--<el-table-column prop="createTime" label="创建时间" align="center" >
        <template slot-scope="{row}">
          <span>{{new Date(row.createTime).format("yyyy-MM-dd")}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center" >
        <template slot-scope="{row}">
          <span>{{new Date(row.updateTime).format("yyyy-MM-dd")}}</span>
        </template>
      </el-table-column>-->
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="{row}">
          <el-button-group>
            <el-button size="mini" icon="el-icon-video-camera-solid" type="primary" @click="edit(row)">修改</el-button>
            <el-button size="mini" icon="el-icon-delete" type="danger" @click="del(row)">删除</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-size="count"
      :page-sizes="[10, 20, 30, 50]"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    <videoEdit ref="videoEdit" ></videoEdit>
  </div>
</template>

<script>
import videoEdit from "./dialog/videoEdit";

export default {
  name: "shipManage",
  components: {
    videoEdit
  },
  data() {
    return {
      videoList: [], //公司列表
      currentPage: 1,
      count: 10,
      total: 0,
      getShipListLoading: false,
    }
  },
  created() {
    this.getVideoList()
  },
  methods:{
    getVideoList(){
      let that = this;
      this.$axios({ method: 'get', url:`/api/video/list`,params: {
          page: this.currentPage,
          count: this.count
        }}).then(function (res) {
        that.videoList = res.data.data.list;
        that.total = res.data.data.total;
      }).catch(function (error) {
        console.log(error);
      });
    },
    currentChange: function (val) {
      this.currentPage = val;
      this.getVideoList();
    },
    handleSizeChange: function (val) {
      this.count = val;
      this.getVideoList();
    },
    add(){
      this.$refs.videoEdit.openDialog(null, this.getVideoList)
    },
    edit(row) {
      this.$refs.videoEdit.openDialog(row, this.getVideoList)
    },
    del(row) {
      let that = this;
      this.$confirm('确认删除此设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getShipListLoading = true;
        this.$axios({ method: 'post', url:`/api/video/delete`, params: {id: row.id, deviceId: row.channelId} }).then( res => {
          if (res.data.code === 200){
            that.$message.success("删除成功！")
            this.getVideoList()
          }else {
            that.$message.error(res.data.msg)
          }
          this.getShipListLoading = false;
        })
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/videoManage.vue